
/**
 * 트윗 태그 정보
 */
export type ExploreContentItemContentOneOfTags = {
  hashtags?: string[];
};
